<template>
  <div class="awesome-table">
    <table>
      <thead>
        <tr>
          <th v-for="(obj, index) in config" :key="index">
            {{ obj.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in customerData" :key="index">
          <td>
            <router-link :to="`mayai_customer_list/${getData(index)}`">
              <span v-if="row.name">{{ row.name }}</span>
              <i v-else>Empty Name</i>
            </router-link>
          </td>
          <td>
            <span v-if="row.loginID">{{ row.loginID }}</span>
            <i v-else>Empty Name</i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ["customerData", "config", "companies"],
  methods: {
    getData(index) {
      if (!this.companies[index]) return false;
      return this.companies[index]._id || { _id: "" };
    }
  }
};
</script>

<style lang="scss">
.awesome-table {
  border: none;
  border-radius: 4px;
  color: #333;
  overflow: auto;
  box-sizing: border-box;
  table {
    border-collapse: collapse;
    width: 100%;
    background-color: white;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.85);
    th {
      position: sticky;
      top: 0;
      background: #f9f9f9;
      padding: 5px 5px;
      text-align: left;
      border: 1px solid rgba(217, 217, 217, 1);
      overflow: hidden;
    }
    td {
      padding: 5px 5px;
      text-align: left;
      border: 1px solid #ddd;
      width: 50%;
    }
    tbody tr:hover {
      background-color: #f3f5f7;
    }
    tbody tr:nth-child(even) {
      background-color: #f9f9f9;
    }
  }
}
</style>
